import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _classCallCheck from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/moongchigo/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import style from './Character.module.css';

var Character = /*#__PURE__*/function (_Component) {
  _inherits(Character, _Component);

  var _super = _createSuper(Character);

  function Character() {
    _classCallCheck(this, Character);

    return _super.apply(this, arguments);
  }

  _createClass(Character, [{
    key: "render",
    value: function render() {
      var type = this.props.type ? this.props.type : 'default';
      return /*#__PURE__*/_jsxs("div", {
        className: "".concat(style.container, " ").concat(this.props.useMarginTop ? style.useMarginTop : ''),
        children: [/*#__PURE__*/_jsx("div", {
          className: "".concat(style.img, "  ").concat(style[type])
        }), /*#__PURE__*/_jsx("div", {
          className: style.text,
          children: this.props.text
        })]
      });
    }
  }]);

  return Character;
}(Component);

export { Character as default };